module.exports = __webpack_public_path__ + "static/02-0a4722f9458abffa5eabbaa7df6186f2.jpg";